/** Événement multi-sessions avec au moins une session configurée. */
export function isMultiSessionEvent(event) {
    return Boolean(event?.is_multi_session) && Array.isArray(event?.sessions) && event.sessions.length > 0;
}

export function isFullEventTicket(ticket) {
    return !ticket?.event_session_id;
}

export function formatSessionDateShort(raw) {
    if (!raw) return '';
    const d = new Date(raw.includes('T') ? raw : `${raw}T12:00:00`);
    if (Number.isNaN(d.getTime())) return raw;
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
}

export function ticketSessionLabel(ticket) {
    if (!ticket) return null;
    if (isFullEventTicket(ticket)) return 'Toute la durée';
    const parts = [ticket.session_label, ticket.session_date ? formatSessionDateShort(ticket.session_date) : null].filter(Boolean);
    return parts.length ? parts.join(' · ') : ticket.session_label || null;
}

export function getTicketTabs(event, tickets = []) {
    if (!isMultiSessionEvent(event)) return [];

    const fullCount = tickets.filter((t) => isFullEventTicket(t)).length;
    const tabs = [];

    if (fullCount > 0) {
        tabs.push({
            id: 'full',
            label: 'Toute la durée',
            sublabel: 'Pass multi-jours',
            count: fullCount,
        });
    }

    (event.sessions || []).forEach((session) => {
        const count = tickets.filter(
            (t) => t.event_session_id === session.id && !isFullEventTicket(t),
        ).length;
        tabs.push({
            id: session.id,
            label: session.label || 'Jour',
            sublabel: session.session_date ? formatSessionDateShort(session.session_date) : '',
            starts_at: session.starts_at,
            ends_at: session.ends_at,
            count,
        });
    });

    return tabs;
}

export function ticketsForTab(tickets, tabId, event) {
    if (!isMultiSessionEvent(event)) return tickets;
    if (tabId === 'full') {
        return tickets.filter((t) => isFullEventTicket(t));
    }
    return tickets.filter((t) => t.event_session_id === tabId && !isFullEventTicket(t));
}

export function countSelectedInTab(tickets, tabId, event, selectedMap = {}) {
    return ticketsForTab(tickets, tabId, event).reduce(
        (sum, t) => sum + (Number(selectedMap[t.id ?? t.pivot_id]) || 0),
        0,
    );
}

export function resolveInitialTicketTab(event, tickets) {
    const tabs = getTicketTabs(event, tickets);
    if (!tabs.length) return null;
    const withTickets = tabs.find((t) => t.count > 0);
    return (withTickets || tabs[0]).id;
}

export function orderSessionLabel(order) {
    if (!order) return null;
    if (order.session_label) {
        const parts = [order.session_label, order.session_date ? formatSessionDateShort(order.session_date) : null].filter(Boolean);
        return parts.join(' · ') || order.session_label;
    }
    if (order.validity_type === 'full_event' && order.is_multi_session) {
        return 'Toute la durée';
    }
    return null;
}
